import TranslationsContext from './TranslationsContext';
import DOMPurify from "dompurify";

const Translate = ({ string }) => {
	return <TranslationsContext.Consumer>{
		({ __ }) => {
			return __(string, 'air-wp-sync');
		}
	}</TranslationsContext.Consumer>
}


export const TranslateHTML = ({ string, allowedHTMLTags = [], allowedHTMLAttrs = [], ...props }) => {
	return <TranslationsContext.Consumer>{
		({ __ }) => {
			return <div { ...props } dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(string(__), { ALLOWED_TAGS: allowedHTMLTags, ALLOWED_ATTR: allowedHTMLAttrs }) }} />;
		}
	}</TranslationsContext.Consumer>
}

/**
 * Fake function for "wp i18n" WP Cli command to find strings.
 */
export const __ = (string) => {
	return <Translate string={ string } />;
}

export default Translate;
